/**
 * QuestionnaireLanguageToggle — 6-language pill switch shared by the
 * Investment Strategy and Psychometric Baseline questionnaires. Content is
 * translated on-demand server-side (see services/questionnaire_i18n.py) and
 * cached per (bank, level, language) — switching is instant after first load.
 */
const LANGUAGES = [
    { id: "en", label: "English" },
    { id: "sw", label: "Kiswahili" },
    { id: "sh", label: "Sheng" },
    { id: "fr", label: "Français" },
    { id: "ar", label: "العربية" },
    { id: "pt", label: "Português" },
];

export default function QuestionnaireLanguageToggle({ value, onChange }) {
    return (
        <div className="inline-flex items-center gap-1 rounded-full border border-border bg-secondary/40 p-1 flex-wrap" data-testid="questionnaire-language-toggle">
            {LANGUAGES.map((l) => (
                <button
                    key={l.id}
                    type="button"
                    onClick={() => onChange(l.id)}
                    data-testid={`questionnaire-language-${l.id}`}
                    aria-pressed={value === l.id}
                    className={
                        "px-2.5 py-1 rounded-full text-xs font-semibold transition-colors " +
                        (value === l.id
                            ? "bg-primary text-primary-foreground"
                            : "text-muted-foreground hover:text-foreground")
                    }
                >
                    {l.label}
                </button>
            ))}
        </div>
    );
}
